import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import {
  surgeryCenterReportDeliveryService,
  CreateSurgeryCenterReportDeliveryInput,
  UpdateSurgeryCenterReportDeliveryInput,
} from "../../services/admin/surgeryCenterReportDelivery.service";

export function useSurgeryCenterReportDeliveryAdmin() {
  return useQuery({
    queryKey: ["surgeryCenterReportDelivery", "admin"],
    queryFn: () => surgeryCenterReportDeliveryService.getAll(),
  });
}

export function useCreateSurgeryCenterReportDelivery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateSurgeryCenterReportDeliveryInput) =>
      surgeryCenterReportDeliveryService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["surgeryCenterReportDelivery"],
      });
      notifications.show({
        title: "Success",
        message: "Surgery center report delivery created successfully",
        color: "green",
      });
    },
    onError: (error: Error) => {
      notifications.show({
        title: "Error",
        message:
          error.message || "Failed to create surgery center report delivery",
        color: "red",
      });
    },
  });
}

export function useUpdateSurgeryCenterReportDelivery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateSurgeryCenterReportDeliveryInput) =>
      surgeryCenterReportDeliveryService.update(input),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["surgeryCenterReportDelivery"],
      });
      notifications.show({
        title: "Success",
        message: "Surgery center report delivery updated successfully",
        color: "green",
      });
    },
    onError: (error: Error) => {
      notifications.show({
        title: "Error",
        message:
          error.message || "Failed to update surgery center report delivery",
        color: "red",
      });
    },
  });
}

export function useToggleSurgeryCenterReportDeliveryActive() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, isActive }: { id: string; isActive: boolean }) =>
      surgeryCenterReportDeliveryService.toggleActive(id, isActive),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["surgeryCenterReportDelivery"],
      });
      notifications.show({
        title: "Success",
        message: "Status updated successfully",
        color: "green",
      });
    },
    onError: (error: Error) => {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to update status",
        color: "red",
      });
    },
  });
}

export function useDeleteSurgeryCenterReportDelivery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => surgeryCenterReportDeliveryService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["surgeryCenterReportDelivery"],
      });
      notifications.show({
        title: "Success",
        message: "Surgery center report delivery deleted successfully",
        color: "green",
      });
    },
    onError: (error: Error) => {
      notifications.show({
        title: "Error",
        message:
          error.message || "Failed to delete surgery center report delivery",
        color: "red",
      });
    },
  });
}
